'use client';

import Navbar from '../ui/Navbar';
import LoginPopup from '../ui/components/popups/LoginPopup';
import NoSubscriptionPopup from '../ui/components/popups/NoSubscriptionPopup';
import UpgradeSubscriptionPopup from '../ui/components/popups/UpgradeSubscriptionPopup';
import { useTelegramInsets } from '@/lib/ui/useTelegramInsets';

import styles from './AppWrapper.module.sass';

export default function AppWrapper({ children }: { children: React.ReactNode }) {
  const insets = useTelegramInsets();
  const hasInsets = insets.top > 0 || insets.right > 0 || insets.bottom > 0 || insets.left > 0;

  return (
    <div
      className={`${styles.wrapper} ${hasInsets ? styles.hasInsets : ''}`}
      style={
        {
          '--tg-top': `${insets.top}px`,
          '--tg-right': `${insets.right}px`,
          '--tg-bottom': `${insets.bottom}px`,
          '--tg-left': `${insets.left}px`,
        } as React.CSSProperties
      }
    >
      <LoginPopup />
      <NoSubscriptionPopup />
      <UpgradeSubscriptionPopup />
      <main className={styles.main}>
        <div className={styles.inner}>{children}</div>
      </main>
      <Navbar />
    </div>
  );
}
